import { FlashMessageDto } from "src/com/sixdee/crbtportal/core/dto/flashmessage/get/flashmessagedto";
import { UIComponentHandler, UIComponentImpl, UIComponentProps, UIComponentState } from "../../../../toolkit/uicomponent";
import { BaseContext } from "src/com/sixdee/crbtportal/utils/basecontext";
import { UIComponentCSSStyle } from "../../../../toolkit/uicomponentcss";
import { UIComponentView } from "../../../../toolkit/uicomponentview";
import { ConfirmFlashMessageCSSStyleImpl } from "./confirmflashmessagecss";
import { ConfirmFlashMessageViewImpl } from "./confirmflashmessageview";

export interface ConfirmFlashMessageComponentProps extends UIComponentProps
{
    headerTitle:string;
    confirmMessage:string;
    closePopup(): void;
    onNoClick():void;
    onYesClick():void;
}

export interface ConfirmFlashMessageComponentState extends  UIComponentState
{
   
}

export interface ConfirmFlashMessageComponentHandler extends UIComponentHandler
{
    onYesClick():void;
    onNoClick(): void;
}

export class ConfirmFlashMessageComponent extends UIComponentImpl<ConfirmFlashMessageComponentProps, ConfirmFlashMessageComponentState, FlashMessageDto> 
implements ConfirmFlashMessageComponentHandler
{
    constructor(props: ConfirmFlashMessageComponentProps, state:ConfirmFlashMessageComponentState)
    {
        super(props);
       
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<FlashMessageDto>
    {
        return new ConfirmFlashMessageViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new ConfirmFlashMessageCSSStyleImpl(applicationContext);
    }

   
    onNoClick()
    {
        this.props.onNoClick();
    }

    onYesClick(): void {
        this.props.onYesClick();

    } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/flashmessage/confirmflashmessage/confirmflashmessagecomponent.tsx